export default "__VITE_ASSET__Bk01wM2V__"